import Head from "next/head";
import "@assets/stylesheets/styles.scss";
import { Provider } from "react-redux";
import { AuthServiceProvider } from "@stadium/services/auth0";
import { ApolloProvider } from "@stadium/services/apollo-client";

import store from "@store/index";
// import "@stadium/services/airbrake";

import AuthWrapper from "@components/auth/wrapper";
import DefaultErrorBoundary from "@components/error-boundary";
import GlobalScripts from "@components/global-scripts";
import LaunchDarklyWrapper from "@components/launch-darkly/wrapper";

import CurrentUserProvider from "@contexts/current-user-provider";

import HOCConfig from "@components/hoc/config";
import SloWrapper from "@components/slo/wrapper";
import Error from "./_error";

import { ESHOP_BRAND } from "@constants/app-defaults";
import { AUDIENCE, CLIENT_ID, CONNECTION, DOMAIN } from "@constants/auth0";

import { client } from "@services/apollo-client";

const App = ({ Component, pageProps }) => (
  <>
    <Head>
      <meta name="viewport" content="width=device-width, initial-scale=1 maximum-scale=1" />
      <meta name="description" content="" />
      <title>STADIUM Shops</title>
    </Head>
    <DefaultErrorBoundary fallback={<Error />}>
      <Provider store={store}>
        <AuthServiceProvider
          audience={AUDIENCE}
          brand={ESHOP_BRAND}
          clientId={CLIENT_ID}
          dbConnection={CONNECTION}
          domain={DOMAIN}
        >
          <GlobalScripts />
          <AuthWrapper>
            <ApolloProvider client={client}>
              <CurrentUserProvider>
                <LaunchDarklyWrapper>
                  <HOCConfig>
                    <SloWrapper>
                      <Component {...pageProps} />
                      <div id="modal-root" />
                    </SloWrapper>
                  </HOCConfig>
                </LaunchDarklyWrapper>
              </CurrentUserProvider>
            </ApolloProvider>
          </AuthWrapper>
        </AuthServiceProvider>
      </Provider>
    </DefaultErrorBoundary>
  </>
);

export default App;
